export const CLIENT_TYPE_META = {
  venue: {
    label: 'Salon de fiestas',
    shortLabel: 'Salon',
    filterLabel: 'Salones',
    theme: 'orange',
  },
  producer: {
    label: 'Productora de eventos',
    shortLabel: 'Productora',
    filterLabel: 'Productoras',
    theme: 'purple',
  },
  creator: {
    label: 'Organizador eventual',
    shortLabel: 'Organizador',
    filterLabel: 'Eventuales',
    theme: 'cyan',
  },
  sports: {
    label: 'Complejo deportivo',
    shortLabel: 'Deportes',
    filterLabel: 'Deportes',
    theme: 'blue',
  },
  events: {
    label: 'Productora de eventos',
    shortLabel: 'Productora',
    filterLabel: 'Productoras',
    theme: 'purple',
  },
};

export const CLIENT_TYPE_OPTIONS = [
  { value: 'venue', label: 'Salon de fiestas', description: 'Espacio fisico que administra fechas, reservas, invitados y cobros.' },
  { value: 'producer', label: 'Productora de eventos', description: 'Organiza eventos recurrentes, vende entradas y opera accesos.' },
  { value: 'creator', label: 'Organizador eventual', description: 'Crea uno o pocos eventos sin mostrar servicios fijos.' },
  { value: 'sports', label: 'Complejo deportivo', description: 'Gestiona torneos, inscripciones y actividad deportiva.' },
];

export const getClientTypeMeta = (type) => CLIENT_TYPE_META[type] || CLIENT_TYPE_META.producer;

export const isPublicVenueType = (type) => type !== 'creator';
